module.exports = __webpack_public_path__ + "img/truck-container.57193b07.svg";